var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"justify":"center","align":"center"}},[_c('v-col',{staticClass:"align-end justify-center d-flex",attrs:{"cols":"2"}},[_c('div',{staticClass:"dot-pulse"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }